export default __webpack_public_path__ + "static/media/frank_gaillard.ba696524.jpg";